<!--
 * @Description: 功能描述
 * @Version: 1.0
 * @Author: Yuchuan
 * @Date: 2022-01-18 15:52:48
-->
<template>
  <div id="app" data-server-rendered="true">
    <!-- 1.头部导航 -->
    <yp-navbar ref="navbar" class="no-transparent-navbar" mobileTitle="荣誉资质"></yp-navbar>
    <!-- 2.背景图 + 标题 -->
    <page-title-bg first-font="n" title-en="OIN US" title-zh="加入我们"></page-title-bg>
    <!-- 3.面包屑导航 -->
    <div class="bread-crumbs-container hidden-xs">
      <div class="container">
        <ol class="breadcrumb">
          <li><a href="/index.html">首页</a></li>
          <li><a href="/friendsImpression.html">加入悦朋</a></li>
          <li class="active">招聘信息</li>
        </ol>
      </div>
    </div>
    <!-- 4.企业简介 -->
    <section class="enterprise-profile-container"></section>
    <!-- 动态弹框 -->
    <!-- 7.footer -->
    <div class="recruitment-box">
      <div class="recruitment-box-content" v-for="(item, index) in recruitmentList" :key="index">
        <div class="recruitment-box-title" @click="gotoDetial(index)">
          <div class="box-title" title="点击查看招聘详情">{{ item.jobTitle }}</div>
          <div class="box-title">招聘中</div>
        </div>
        <div class="salary-box" @click="gotoDetial(index)">
          <span>{{ item.positionSalary }}</span> {{ item.jobRequirements }}
        </div>
        <div class="button-box">
          <div class="button-box-content">
            <div v-show="item.jobDescription.length > 0" class="button-class" v-for="(itemt, indext) in item.jobDescription" :key="indext">{{ itemt }}</div>
          </div>
          <div class="button-class-big" data-target="#myModal" data-toggle="modal">邮箱投递简历</div>
          <!-- Button trigger modal -->
        </div>
        <div class="button-class-content-fontsize" @click="gotoDetial(index)">{{ item.content }}</div>
      </div>
      <div class="recruitment-box-content test" @click.capture="gotoDetial(5)">
        <div class="recruitment-box-title" @click.capture="gotoDetial(5)">
          <div class="box-title">所有岗位实习生</div>
          <div class="box-title-student">校招</div>
        </div>
        <div class="padding20px">
          <div class="salary-box" @click.capture="gotoDetial(5)"><span>2.5千-3.5千</span> 威海 | 3-5年 | 大专 | 全职 | 招1人</div>
          <div class="button-box">
            <div class="button-box-content"></div>
            <div class="button-class-big" data-target="#myModal" data-toggle="modal">邮箱投递简历</div>
          </div>
          <div class="button-class-content-fontsize" @click.capture="gotoDetial(5)">专业理论基础知识点扎实，逻辑思维能力强、学习能力强、有良好的自驱力，对工作积极主动，责任心强，对同事团结友爱。</div>
        </div>
      </div>
    </div>
    <div class="modal fade" id="myModal" tabindex="-1" role="dialog" aria-labelledby="myModalLabel">
      <div class="modal-dialog" role="document">
        <div class="modal-content">
          <div class="modal-header">
            <button type="button" class="close" data-dismiss="modal" aria-label="Close"><span aria-hidden="true">&times;</span></button>
            <h4 class="modal-title" id="myModalLabel">邮箱</h4>
          </div>
          <div class="modal-body">sdyp_intel@163.com</div>
          <div class="modal-footer"></div>
        </div>
      </div>
    </div>
    <yp-footer></yp-footer>
  </div>
</template>
<script>
import YpNavbar from '@/components/navbar.vue'
import PageTitleBg from '@/components/page-title-bg.vue'
import YpFooter from '@/components/footer.vue'
export default {
  components: {
    YpNavbar,
    PageTitleBg,
    YpFooter,
  },
  data() {
    return {
      recruitmentList: [
        {
          jobTitle: 'Java开发工程师',
          positionSalary: '7千-1.4万',
          jobRequirements: '威海 | 3-5年 | 本科 | 全职 | 招5人',
          jobDescription: ['后端开发', '系统架构'],
          content: '参与项目需求分析、系统设计、模块设计、软件开发、集成测试、运行维护工作。',
        },
        {
          jobTitle: 'web前端工程师',
          positionSalary: '6千-8千',
          jobRequirements: '威海 | 3-5年 | 大专 | 全职 | 招2人',
          jobDescription: ['HTML'],
          content: '负责公司产品WEB端模块功能的设计、实现工作；项目的页面编写、Javascript数据处理、Ajax数据交互。',
        },
        {
          jobTitle: '测试工程师',
          positionSalary: '4千-5千',
          jobRequirements: '威海 | 3-5年 | 大专 | 全职 | 招2人',
          jobDescription: ['后端开发', '系统架构'],
          content: '落实测试计划，配合推进测试工作进度；根据实际情况及时汇报测试进度，根据需求和设计文档，提交测试方案。',
        },
        {
          jobTitle: '运维工程师',
          positionSalary: '5千-8千',
          jobRequirements: '威海 | 3-5年 | 大专 | 全职 | 招1人',
          jobDescription: [],
          content: '掌握网络、服务器硬件、操作系统、数据库知识，了解运维工作职责。能够搭建和管理基于Vmware的虚拟化平台具有日常巡检、系统升级切换及故障报告的技术文档编写的能力。',
        },
        {
          jobTitle: '产品助理',
          positionSalary: '4千-6千',
          jobRequirements: '威海 | 3-5年 | 大专 | 全职 | 招1人',
          jobDescription: ['网页产品', 'APP产品'],
          content: '协助产品经理做好产品市场分析、竞品分析、完成需求收集、产品设计、项目跟踪、上线验收及交付运营迭代等工作。',
        },
      ],
      mouserindex: '10',
      // 悦朋福利列表
      welfareList: [
        {
          img: require('../../../public/static/img/socialInsurance.png'),
          title: '社会保险',
          content: '公司为员工缴纳养老、医疗、工伤、失业、生育保险，给员工提供安心的社会保障。',
          className: 'img-socialInsurancebc',
        },
        {
          img: require('../../../public/static/img/housingAccumulaton.png'),
          title: '住房公积金',
          content: '为帮助员工减轻住房压力，为员工缴纳住房公积金，在员工有购房消费需求时，住房公积金可以助员工圆住房梦。',
          className: 'img-housingAccumulaton',
        },
        {
          img: require('../../../public/static/img/commercialInsurance.png'),
          title: '商业保险',
          content: '公司为每一位员工购买商业意外保险，保险费用由公司全额支付。',
          className: 'img-commercialInsurance',
        },
        {
          img: require('../../../public/static/img/holidayGreetings.png'),
          title: '节日问候',
          content: '中秋、端午每个特殊的节日，公司会为您精心提供一份节日福利。',
          className: 'img-holidayGreetings',
        },
        {
          img: require('../../../public/static/img/birthdayPresent.png'),
          title: '生日礼物',
          content: '为每个特别的你奉上一份生日蛋糕。',
          className: 'img-birthdayPresent',
        },
        {
          img: require('../../../public/static/img/paidVacation.png'),
          title: '带薪假期',
          content: '为了保障悦朋人的工作与生活平衡，提供了多样的带薪假期：如调休假、病假、孕期检查假，同时也享受法定的：产假、陪产假、婚假等。',
          className: 'img-paidVacation',
        },
        {
          img: require('../../../public/static/img/fitnessField.png'),
          title: '健身场地',
          content: '园区大楼四楼配备有多样的健身器材，工作之余还可以强身健体',
          className: 'img-fitnessField',
        },
        {
          img: require('../../../public/static/img/medicalStaff.png'),
          title: '员工体检',
          content: '公司提供两年一度的身体健康检查，全面检测大家的身体状况，尽早预防各类健康风险。',
          className: 'img-medicalStaff',
        },
      ],
    }
  },
  methods: {
    // 鼠标滑动事件
    mouserindexEvent(index) {
      this.mouserindex = index
    },
    mouserOutEvent() {
      this.mouserindex = 9
    },
    // 跳转其他页面
    gotoDetial(index) {
      window.location.href = `/pages/campusRecruitment.html?index=${index}`
    },
    test() {},
  },
  created() {
    Media($(window).width())
    function Media(width) {
      if (width > 750) {
        refreshRem(1920)
      } else {
        refreshRem(750)
      }
    }
    // 根据设计图尺寸计算rem
    function refreshRem(designSize) {
      let html = document.documentElement
      let wW = html.clientWidth // 窗口宽度
      let rem = (wW * 100) / designSize
      document.documentElement.style.fontSize = rem + 'px'
    }
  },
}
</script>
<style lang="scss">
#app {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
}

#nav {
  padding: 30px;

  a {
    font-weight: bold;
    color: #2c3e50;

    &.router-link-exact-active {
      color: #42b983;
    }
  }
}
</style>
